/**
 * Which drills exist, and which do not.
 *
 * ===================== WHY THE DEAD ONES ARE ON THE LIST ========================
 * Only one drill is real: preflop shove-or-fold, which is the only thing the pipeline
 * has solved. The four streets underneath it are drawn, disabled, and labelled "not
 * yet" — the same treatment the knockout button gets, for the same reason.
 *
 * The alternative was to show one item, which reads as a finished product with one
 * feature rather than a library that is being filled in. The alternative to THAT was
 * to ship postflop drills off a heuristic model, which is the one thing the standing
 * guardrail forbids: a combination that cannot be solved exactly is disabled, never
 * quietly replaced by a near-enough answer. So they are on the list, they do not work,
 * and each one says why in the plainest words available.
 * ================================================================================
 *
 * The list lives in a `.ts` file rather than beside the component so a test can read
 * it. The tests project does not compile JSX, and "which drills claim to work" is
 * exactly the assertion worth having.
 */
export interface Drill {
  id: string;
  label: string;
  caption: string;
  live: boolean;
}

export const DRILLS: Drill[] = [
  { id: "preflop", label: "Preflop", caption: "Shove or fold", live: true },
  { id: "flop", label: "Flop", caption: "Not yet — no flop solves exist", live: false },
  { id: "turn", label: "Turn", caption: "Not yet — no turn solves exist", live: false },
  { id: "river", label: "River", caption: "Not yet — no river solves exist", live: false },
  { id: "full", label: "Full hand", caption: "Not yet — needs all four streets", live: false },
];
